var React = require('react');

function WarningElectricity (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"safety-warning-electricity"),React.createElement("path",{"d":"M23.9,22.163,12.81.974a.948.948,0,0,0-1.619,0L.105,22.159a.891.891,0,0,0-.1.421.9.9,0,0,0,.9.9H23.1a.9.9,0,0,0,.9-.9A.885.885,0,0,0,23.9,22.163Zm-9.673-6.952-1.338,2.675a.251.251,0,0,0,.125.342l.686.293a.5.5,0,0,1-.011.924l-2.5,1a.488.488,0,0,1-.186.036.5.5,0,0,1-.464-.314l-1-2.5a.5.5,0,0,1,.115-.543.5.5,0,0,1,.546-.1l.973.418a.25.25,0,0,0,.322-.118L12.6,15.1a.249.249,0,0,0-.223-.361l-1.881,0A1.334,1.334,0,0,1,9.238,12.76l2.581-5.593a.75.75,0,0,1,1.362.629l-2.344,5.077a.253.253,0,0,0,.017.24.247.247,0,0,0,.21.115l1.936,0a1.312,1.312,0,0,1,1.224,1.98Z","key":1})]);
}

WarningElectricity.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = WarningElectricity;

WarningElectricity.default = WarningElectricity;
